module.exports = __webpack_public_path__ + "static/media/RELIANCE.0960a287.txt";